export default __webpack_public_path__ + "static/media/solution_success_treasure_icon.6e431126.svg";